import React from 'react'

export default function Page() {
  return (
    <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"80vh"}}>
       <img src={`/c25729131efb71198034c0275c21aea8.gif`} width={"50%"}/>
    </div>
  )
}
